import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f18bae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "ModalUploadInvoiceXMLFile",
  tabindex: "-1",
  "aria-labelledby": `ModalUploadInvoiceXMLFile`,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header gap-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.5",
    d: "M11.5642 15.4993H8.43874C7.91913 15.4993 7.5011 15.0812 7.5011 14.5616V7.99817H4.07482C3.3794 7.99817 3.03169 7.1582 3.52395 6.66594L9.46623 0.719759C9.75924 0.426747 10.2398 0.426747 10.5328 0.719759L16.479 6.66594C16.9712 7.1582 16.6235 7.99817 15.9281 7.99817H12.5018V14.5616C12.5018 15.0812 12.0838 15.4993 11.5642 15.4993ZM20.0029 15.1867V19.5624C20.0029 20.082 19.5849 20.5 19.0653 20.5H0.937637C0.41803 20.5 0 20.082 0 19.5624V15.1867C0 14.6671 0.41803 14.2491 0.937637 14.2491H6.25092V14.5616C6.25092 15.7688 7.23153 16.7495 8.43874 16.7495H11.5642C12.7714 16.7495 13.752 15.7688 13.752 14.5616V14.2491H19.0653C19.5849 14.2491 20.0029 14.6671 20.0029 15.1867ZM15.1585 18.6247C15.1585 18.195 14.8069 17.8434 14.3771 17.8434C13.9474 17.8434 13.5957 18.195 13.5957 18.6247C13.5957 19.0545 13.9474 19.4061 14.3771 19.4061C14.8069 19.4061 15.1585 19.0545 15.1585 18.6247ZM17.6588 18.6247C17.6588 18.195 17.3072 17.8434 16.8775 17.8434C16.4477 17.8434 16.0961 18.195 16.0961 18.6247C16.0961 19.0545 16.4477 19.4061 16.8775 19.4061C17.3072 19.4061 17.6588 19.0545 17.6588 18.6247Z",
    fill: "var(--cor_texto_1)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.5641 15.4993H8.43869C7.91908 15.4993 7.50105 15.0812 7.50105 14.5616V7.99817H4.07477C3.37935 7.99817 3.03164 7.1582 3.5239 6.66594L9.46618 0.719759C9.75919 0.426747 10.2397 0.426747 10.5327 0.719759L16.4789 6.66594C16.9712 7.1582 16.6235 7.99817 15.9281 7.99817H12.5018V14.5616C12.5018 15.0812 12.0838 15.4993 11.5641 15.4993Z",
    fill: "var(--cor_texto_1)"
  })
], -1))
const _hoisted_6 = {
  class: "modal-title",
  id: "ModalUploadInvoiceXMLFileLabel",
  style: {"color":"var(--cor_texto_1)","margin-right":"auto"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"background-color":"transparent","border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.6641 9L17.5503 4.11377C18.1499 3.51416 18.1499 2.54199 17.5503 1.94189L16.4644 0.855957C15.8647 0.256348 14.8926 0.256348 14.2925 0.855957L9.40625 5.74219L4.52002 0.855957C3.92041 0.256348 2.94824 0.256348 2.34814 0.855957L1.26221 1.94189C0.662598 2.5415 0.662598 3.51367 1.26221 4.11377L6.14844 9L1.26221 13.8862C0.662598 14.4858 0.662598 15.458 1.26221 16.0581L2.34814 17.144C2.94775 17.7437 3.92041 17.7437 4.52002 17.144L9.40625 12.2578L14.2925 17.144C14.8921 17.7437 15.8647 17.7437 16.4644 17.144L17.5503 16.0581C18.1499 15.4585 18.1499 14.4863 17.5503 13.8862L12.6641 9Z",
      fill: "#B5B5C3"
    })
  ])
], -1))
const _hoisted_8 = {
  class: "modal-body p-4",
  style: {"background-color":"var(--cor_background_2)"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  style: {"color":"var(--cor_texto_1)"},
  class: "mb-1 py-1"
}, "Verifique os itens antes de Enviar", -1))
const _hoisted_10 = {
  key: 0,
  class: "row g-4"
}
const _hoisted_11 = {
  key: 0,
  class: "col-12 d-flex d-md-none align-items-start justify-content-end"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1rem","color":"var(--cor_icones_1)"}
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nota Fiscal:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nome do arquivo:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "col-md-2 d-none d-md-flex align-items-start justify-content-end"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1rem","color":"var(--cor_icones_1)"}
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "col-md-6 d-flex flex-column" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "w-100" }, "Emitente:", -1))
const _hoisted_27 = {
  key: 0,
  style: {"color":"var(--cor_indicadores_4)"},
  class: "w-100"
}
const _hoisted_28 = { class: "col-md-6 d-flex flex-column" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "w-100" }, "Destinatário:", -1))
const _hoisted_30 = {
  key: 0,
  style: {"color":"var(--cor_indicadores_4)"},
  class: "w-100"
}
const _hoisted_31 = {
  key: 1,
  style: {"color":"var(--cor_indicadores_4)"},
  class: "w-100"
}
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = {
  id: "box-table-items",
  class: "rounded",
  style: {"border":"1px solid var(--cor_background_2)"}
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "w-100" }
const _hoisted_36 = {
  key: 0,
  style: {"color":"var(--cor_indicadores_4)"},
  class: "w-100"
}
const _hoisted_37 = {
  key: 1,
  style: {"color":"var(--cor_indicadores_3)"},
  class: "w-100"
}
const _hoisted_38 = {
  key: 2,
  style: {"color":"var(--cor_indicadores_3)"},
  class: "w-100"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  style: {"color":"var(--cor_texto_1)"},
  class: "mb-1 py-1"
}, "Resumo do envio", -1))
const _hoisted_40 = { class: "invoices-feedback card rounded mt-4 p-4" }
const _hoisted_41 = { style: {"color":"var(--cor_texto_1)"} }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-sm-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Emitente:", -1))
const _hoisted_45 = { class: "col-sm-6" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Destinatário:", -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  class: "mt-2",
  style: {"color":"var(--cor_indicadores_1)"}
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  id: "box-table-items",
  class: "rounded",
  style: {"border":"1px solid var(--cor_background_2)"}
}
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  class: "mt-2",
  style: {"color":"var(--cor_indicadores_3)"}
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  id: "box-table-items",
  class: "rounded",
  style: {"border":"1px solid var(--cor_background_2)"}
}
const _hoisted_57 = { key: 2 }
const _hoisted_58 = {
  class: "mt-2",
  style: {"color":"var(--cor_indicadores_3)"}
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = {
  id: "box-table-items",
  class: "rounded",
  style: {"border":"1px solid var(--cor_background_2)"}
}
const _hoisted_62 = { key: 3 }
const _hoisted_63 = {
  class: "mt-2",
  style: {"color":"var(--cor_indicadores_4)"}
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = {
  id: "box-table-items",
  class: "rounded",
  style: {"border":"1px solid var(--cor_background_2)"}
}
const _hoisted_67 = { key: 4 }
const _hoisted_68 = {
  class: "mt-2",
  style: {"color":"var(--cor_indicadores_4)"}
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = {
  id: "box-table-items",
  class: "rounded",
  style: {"border":"1px solid var(--cor_background_2)"}
}
const _hoisted_72 = { class: "invoices-feedback card rounded mt-4 p-4" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"color":"var(--cor_indicadores_4)"} }, "Erro", -1))
const _hoisted_74 = { class: "modal-footer gap-4" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn background_btn_1_opct m-0",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-times",
    "aria-hidden": "true",
    style: {"margin":"0","padding":"0","font-size":"1.25rem","color":"var(--cor_btn_1)"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Cancelar")
], -1))
const _hoisted_76 = {
  key: 0,
  class: "btn background_btn_1_opct m-0"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-upload",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.25rem","color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Nota Fiscal", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.25rem","color":"var(--cor_icones_1)"}
}, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Enviar", -1))
const _hoisted_81 = [
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = {
  key: 2,
  style: {"color":"var(--cor_icones_1)"},
  class: "btn background_btn_1 m-0"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-file",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.25rem","color":"var(--cor_icones_1)"}
}, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Novo", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.header), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.successFeedback.length && !_ctx.failFeedback.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (Array.isArray(_ctx.invoiceInfoList) && _ctx.invoiceInfoList.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceInfoList, (invoiceInfo, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["card p-4", `${index > 0 ? 'mt-4 mb-0' : 'mb-0'}`])
                        }, [
                          (invoiceInfo?.parsedXMLData)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_ctx.invoiceInfoList.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createElementVNode("button", {
                                        class: "btn btn btn-sm background_btn_1_opct btn-sm",
                                        style: {"color":"var(--cor_icones_1)"},
                                        onClick: () => _ctx.removeInvoiceInfo(index)
                                      }, _hoisted_14, 8, _hoisted_12)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _hoisted_17,
                                  _createTextVNode(" " + _toDisplayString(`${invoiceInfo.parsedXMLData.ide.nNF}/${invoiceInfo.parsedXMLData.ide.serie} - ${invoiceInfo.parsedXMLData.ide.natOp} - ${_ctx.moment(invoiceInfo.parsedXMLData.ide.dhEmi).format('DD/MM/YYYY')}`), 1)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  (invoiceInfo?.XMLFile?.name)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_19,
                                        _hoisted_20,
                                        _createTextVNode(" " + _toDisplayString(invoiceInfo.XMLFile.name), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.invoiceInfoList.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _createElementVNode("button", {
                                        class: "btn btn btn-sm background_btn_1_opct btn-sm",
                                        style: {"color":"var(--cor_icones_1)"},
                                        onClick: () => _ctx.removeInvoiceInfo(index)
                                      }, _hoisted_24, 8, _hoisted_22)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_25, [
                                  _hoisted_26,
                                  _createTextVNode(" " + _toDisplayString(`${invoiceInfo.parsedXMLData.emit.xFant} - ${invoiceInfo.parsedXMLData.emit.CNPJ}`) + " ", 1),
                                  (invoiceInfo.itemsChecked?.company)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_27, " Cadastro não encontrado "))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createTextVNode(" " + _toDisplayString(`${invoiceInfo.parsedXMLData.dest.xNome} - ${invoiceInfo.parsedXMLData.dest.CNPJ}`) + " ", 1),
                                  (invoiceInfo.itemsChecked?.store)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_30, " Cadastro não encontrado "))
                                    : _createCommentVNode("", true),
                                  (invoiceInfo.itemsChecked?.storeByCompany)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_31, " Loja não vinculada "))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_CampTable, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createVNode(_component_CampTableTh, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Itens")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_CampTableTh, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("SKU")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_CampTableTh, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Cod.")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_CampTableTh, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Qtd.")
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        (Array.isArray(invoiceInfo.parsedXMLData.det) && invoiceInfo.parsedXMLData.det.length > 0)
                                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_34, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceInfo.parsedXMLData.det, (item) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                  _createVNode(_component_CampTableTd, { class: "py-2 d-flex flex-wrap" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_35, _toDisplayString(item.prod.xProd), 1),
                                                      (invoiceInfo.itemsChecked?.auxItems.find(el => el == item.prod.cProd))
                                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_36, " Produto não encontrado "))
                                                        : _createCommentVNode("", true),
                                                      (invoiceInfo.itemsChecked?.stockItems.find(el => el == item.prod.cProd))
                                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_37, " Já deu entrada na Loja "))
                                                        : _createCommentVNode("", true),
                                                      (invoiceInfo.itemsChecked?.giftItems.find(el => el == item.prod.cProd))
                                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_38, " Este produto é um brinde "))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.prod.cEAN), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.prod.cProd), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.prod.qTrib), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]))
                                              }), 256))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 256))
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_39,
                (_ctx.successFeedback.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.successFeedback, (feedback) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("h5", _hoisted_41, "Nota Fiscal de Nº " + _toDisplayString(feedback.data.data.note.numero_nota_fiscal), 1),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _hoisted_44,
                            _createTextVNode(" " + _toDisplayString(`${feedback.data.data.note.nome_fantasia_companhia} - ${feedback.data.data.note.cnpj_companhia}`), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createTextVNode(" " + _toDisplayString(`${feedback.data.data.note.nome_loja} - ${feedback.data.data.note.cnpj_loja}`), 1)
                          ])
                        ]),
                        (Array.isArray(feedback.data.data.result.success.items) && feedback.data.data.result.success.items.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createElementVNode("h6", _hoisted_48, [
                                (feedback.data.data.result.success.items.length < 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, " Entrada no estoque "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_50, " Entradas no estoque "))
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_CampTable, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Itens")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("SKU")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cod.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Qtd.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedback.data.data.result.success.items, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.desc), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.sku), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.cod), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.qtd), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 256))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Array.isArray(feedback.data.data.result.ignored.items) && feedback.data.data.result.ignored.items.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("h6", _hoisted_53, [
                                (feedback.data.data.result.ignored.items.length < 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, " Brinde (Desconsiderado para estoque) "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_55, " Brindes (Desconsiderados para estoque) "))
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _createVNode(_component_CampTable, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Itens")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("SKU")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cod.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Qtd.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedback.data.data.result.ignored.items, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.desc), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.sku), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.cod), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.qtd), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 256))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Array.isArray(feedback.data.data.result.inStock.items) && feedback.data.data.result.inStock.items.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _createElementVNode("h6", _hoisted_58, [
                                (feedback.data.data.result.inStock.items.length < 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_59, " Já deu entrada anteriormente "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_60, " Já deram entrada anteriormente "))
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createVNode(_component_CampTable, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Itens")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("SKU")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cod.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Qtd.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedback.data.data.result.inStock.items, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.desc), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.sku), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.cod), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.qtd), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 256))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Array.isArray(feedback.data.data.result.noStock.items) && feedback.data.data.result.noStock.items.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createElementVNode("h6", _hoisted_63, [
                                (feedback.data.data.result.noStock.items.length < 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, " Sem Estoque! "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_65, " Sem Estoque! "))
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _createVNode(_component_CampTable, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Itens")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("SKU")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cod.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Qtd.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedback.data.data.result.noStock.items, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.desc), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.sku), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.cod), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.qtd), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 256))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Array.isArray(feedback.data.data.result.unregistered.items) && feedback.data.data.result.unregistered.items.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              _createElementVNode("h6", _hoisted_68, [
                                (feedback.data.data.result.unregistered.items.length < 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, " Registro não encontrado "))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_70, " Registros não encontrados "))
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _createVNode(_component_CampTable, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Itens")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("SKU")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cod.")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_CampTableTh, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Qtd.")
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedback.data.data.result.unregistered.items, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.desc), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.sku), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.cod), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_CampTableTd, { class: "py-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.qtd), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 256))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  : _createCommentVNode("", true),
                (_ctx.failFeedback.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.failFeedback, (feedback) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _hoisted_73,
                        _createElementVNode("p", null, _toDisplayString(feedback), 1)
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          (!_ctx.successFeedback.length && !_ctx.failFeedback.length && _ctx.invoiceInfoList.length < _ctx.maxUploads)
            ? (_openBlock(), _createElementBlock("label", _hoisted_76, [
                _createElementVNode("input", {
                  class: "d-none",
                  type: "file",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleXMLFileChange && _ctx.handleXMLFileChange(...args))),
                  multiple: ""
                }, null, 32),
                _hoisted_77,
                _hoisted_78
              ]))
            : _createCommentVNode("", true),
          (!_ctx.successFeedback.length && !_ctx.failFeedback.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                style: {"color":"var(--cor_icones_1)"},
                class: "btn background_btn_1 m-0",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fire && _ctx.fire(...args)))
              }, _hoisted_81))
            : (_openBlock(), _createElementBlock("label", _hoisted_82, [
                _createElementVNode("input", {
                  class: "d-none",
                  type: "file",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.initNewPost && _ctx.initNewPost(...args))),
                  multiple: ""
                }, null, 32),
                _hoisted_83,
                _hoisted_84
              ]))
        ])
      ])
    ])
  ]))
}